<div class="d-flex justify-content-center align-items-center">
  <span class="d-inline-flex align-items-center gap-2 px-3 py-3 text-white" (click)="menuProductos()" style="cursor: pointer">
    <i class="ti ti-arrow-left"></i>
    PRODUCTOS
  </span>
</div>

@if (!item().hidden) {
  <li class="nav-item coded-menu-caption flex-container">
    <label class="tituloNav">{{ item().title | translate }}</label>

    @if (item().title === 'Trueque') {
      <div class="count-down-timer">
        <div class="wrapper">
          <div class="time-box">
            <p class="m-0">Día</p>
            <p class="number" #days>00</p>
          </div>
          <div class="time-box">
            <p class="m-0">Hor</p>
            <p class="number" #hours>00</p>
          </div>
          <div class="time-box">
            <p class="m-0">Min</p>
            <p class="number" #minutes>00</p>
          </div>
          <div class="time-box">
            <p class="m-0">Seg</p>
            <p class="number" #seconds>00</p>
          </div>
        </div>
        <!-- <button type="button" class="btn btn-primary botones btnSalir" (click)="cerrarPeriodoCompensacion()">
          <i class="ti ti-lock me-1" matTooltip="Bloquear Periodo"></i>
        </button> -->
      </div>
    }
  </li>

  @for (items of item().children; track $index) {
    @if (items.type === 'collapse') {
      <app-menu-collapse [item]="items" [parentRole]="item().role" />
    } @else if (items.type === 'item') {
      <app-menu-item [item]="items" [parentRole]="item().role" />
    }
  }
}
